"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const RadioInput = (_a) => {
    var { id, name, value, label, isInvalid, className = '', disabled = false, ariaLabelledBy } = _a, rest = __rest(_a, ["id", "name", "value", "label", "isInvalid", "className", "disabled", "ariaLabelledBy"]);
    return ((0, jsx_runtime_1.jsxs)("label", { className: `${className} radio-label ${isInvalid ? 'label-invalid' : ''}`, htmlFor: id, children: [(0, jsx_runtime_1.jsx)(formik_1.Field, Object.assign({ type: "radio", id: id, name: name, value: value, className: `${className} radio-input ${isInvalid ? 'invalid' : ''}`, tabIndex: "0", disabled: disabled, "aria-labelledby": ariaLabelledBy }, rest)), (0, jsx_runtime_1.jsx)("span", { "aria-label": ariaLabelledBy, className: `${className} radio-label-text ${disabled ? 'disabled' : ''}`, children: label })] }));
};
exports.default = RadioInput;
